import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';

import { provideAnimations } from '@angular/platform-browser/animations';
import { NG_EVENT_PLUGINS } from '@taiga-ui/event-plugins';
import {
  TUI_LANGUAGE,
  TUI_RUSSIAN_LANGUAGE,
  TuiLanguage,
} from '@taiga-ui/i18n';
import { of } from 'rxjs';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideMetrikaSpaTracking } from './services/metrika-spa-tracking.provider';

const AVAILABLE_LANGS = ['ru', 'gb', 'es', 'pt', 'de', 'tr', 'ar', 'zh', 'kr', 'ja', 'id'] as const;

function getInitialLang(): string {
  try {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem('bk_lang');
      if (stored && (AVAILABLE_LANGS as readonly string[]).includes(stored)) {
        return stored;
      }
    }
  } catch {
    // ignore
  }
  return 'ru';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(),
    NG_EVENT_PLUGINS,
    {
      provide: TUI_LANGUAGE,
      useValue: of(TUI_RUSSIAN_LANGUAGE),
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideMetrikaSpaTracking(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideTransloco({
      config: {
        availableLangs: ['ru', 'gb', 'es', 'pt', 'de', 'tr', 'ar', 'zh', 'kr', 'ja', 'id'],
        defaultLang: getInitialLang(),
        fallbackLang: 'gb',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
